// import React, { useEffect, useCallback } from "react";
// import { useDrag, useDrop } from "react-dnd";
// import HalfCard from "./HalfCard";

// const DraggableCard = React.memo(({ index, group, card, moveCard, selectedCardId, isFullLast, isShowType, isShowPickedSymbol, onHandleClick }) => {
//   const [{ isDragging }, drag, preview] = useDrag({
//     type: "DRAGGABLE-CARD",
//     item: { index, card },
//     collect: (monitor) => ({
//       isDragging: monitor.isDragging(),
//     }),
//   });

//     const handleHover = useCallback(
//     (item) => {
//       // console.log('card', card.group);
//       if (item.index !== index || item.card.group !== group) {
//         console.log('update handleHover')
//         item.card.group = group;
//         item.index = index;
//         moveCard(item.card.cardId, card.cardId);
//       }
//     },
//     [index, group, card]
//   );

//   // const handleHover = useCallback(
//   //   (item) => {
//   //     if (item.index !== index) {
//   //       moveCard(item.index, index);
//   //       item.index = index;
//   //     }
//   //   },
//   //   [index, card, moveCard]
//   // );

//   const [, drop] = useDrop({
//     accept: "DRAGGABLE-CARD",
//     hover: handleHover,
//   });

//   useEffect(() => {
//     preview(new Image()); // Transparent drag preview
//   }, [preview]);

//   return (
//     <div
//       key={card.cardId}
//       ref={(node) => drag(drop(node))}
//       className={`pokerCard-item ${selectedCardId?.includes(card.cardId)  ? "selected" : ""} ${isDragging ? "dragging" : ""}`}
//       onClick={() => onHandleClick(card.cardId)}
//     >
//       <HalfCard card={card} cardStyle={{ opacity: 1 }} isFullLast={isFullLast} isShowType={isShowType} isShowPickedSymbol={isShowPickedSymbol} />
//     </div>
//   );
// });

// export default DraggableCard;


// import React, { useEffect, useCallback } from "react";
// import { useDrag, useDrop } from "react-dnd";
// import HalfCard from "./HalfCard";

// const DraggableCard = React.memo(({ index, group, card, moveCard, selectedCardId, isFullLast, isShowType, isShowPickedSymbol, isShowMoneySymbol, onHandleClick }) => {
//   const [{ isDragging }, drag, preview] = useDrag({
//     type: "DRAGGABLE-CARD",
//     item: { index, card },
//     collect: (monitor) => ({
//       // isDragging: monitor.isDragging(),
//       isDragging: monitor.isDragging() || monitor.getItem()?.card?.cardId === card?.cardId,
//     }),
//   });

  
//   const handleHover = useCallback(
//     (item) => {
//       // console.log('card', card.group);
//       if (item.index !== index || item.card.group !== group) {
//         item.card.group = group;
//         item.index = index;
//         moveCard(item.card.cardId, card.cardId);
//       }
//     },
//     [index, group, card, moveCard]
//   );

//   const [, drop] = useDrop({
//     accept: "DRAGGABLE-CARD",
//     hover: handleHover,
//   });

//   useEffect(() => {
//     preview(new Image()); // Transparent drag preview
//   }, [preview]);

//   return (
//     <div
//       key={card.cardId}
//       ref={(node) => drag(drop(node))}
//       className={`pokerCard-item ${selectedCardId?.includes(card.cardId)  ? "selected" : ""} ${isDragging ? "dragging" : ""}`}
//       onClick={() => onHandleClick(card.cardId)}
//     >
//       <HalfCard card={card} cardStyle={{ opacity: 1 }} isFullLast={isFullLast} isShowType={isShowType} isShowPickedSymbol={isShowPickedSymbol} isShowMoneySymbol={isShowMoneySymbol} />
//     </div>
//   );
// });

// export default DraggableCard;


import React, { useEffect, useCallback } from "react";
import { useDrag, useDrop } from "react-dnd";
import HalfCard from "./HalfCard";

const DraggableCard = React.memo(({ index, group, card, moveCard, selectedCardId, isFullLast, isShowType, isShowPickedSymbol, isShowMoneySymbol, onHandleClick }) => {
  const [{ isDragging }, drag, preview] = useDrag({
    type: "DRAGGABLE-CARD",
    item: { index, card },
    collect: (monitor) => ({
      // isDragging: monitor.isDragging(),
      isDragging: monitor.isDragging() || monitor.getItem()?.card?.cardId === card?.cardId,
    }),
  });

  
  const handleHover = useCallback(
    (item) => {
      if (item.index !== index || item.card.group !== group) {
        // React DnD calls hover as soon as the dragged card touches this card.
        // Switch immediately; no centre or one-third crossing is required.
        item.card.group = group;
        item.index = index;
        moveCard(item.card.cardId, card.cardId);
      }
    },
    [index, group, card, moveCard]
  );

  const [, drop] = useDrop({
    accept: "DRAGGABLE-CARD",
    hover: handleHover,
  });

  useEffect(() => {
    preview(new Image()); // Transparent drag preview
  }, [preview]);

  return (
    <div
      key={card.cardId}
      ref={(node) => drag(drop(node))}
      className={`pokerCard-item ${selectedCardId?.includes(card.cardId)  ? "selected" : ""} ${isDragging ? "dragging" : ""}`}
      onClick={() => onHandleClick(card.cardId)}
    >
      <HalfCard card={card} cardStyle={{ opacity: 1 }} isFullLast={isFullLast} isShowType={isShowType} isShowPickedSymbol={isShowPickedSymbol} isShowMoneySymbol={isShowMoneySymbol} />
    </div>
  );
});

export default DraggableCard;
